export enum ControleEstoqueListaRefinamentoEnum {
  Descricao = 1,
  CodigoSku = 2,
  GtinEan = 3,
  CodigoFornecedor = 4,
  NumeroSerie = 5,
}
